import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import AssistantAskBar from './AssistantAskBar'
import { useAssistant } from './AssistantProvider'

/**
 * Ask Attorney Share's place in the top bar, before Messages and the bell.
 * Nothing with the flag off (no provider), signed out or on /assistant.
 */
const AssistantTopBar = ({ compact }: { compact: boolean }) => {
  const assistant = useAssistant()
  const { pathname } = useLocation()
  const isAvailable = Boolean(assistant?.isAvailable)
  const registerTopBar = assistant?.registerTopBar

  // Lets the dock know the button is here to act on a nudge it says aloud.
  useEffect(() => {
    if (!isAvailable || !registerTopBar) return undefined
    return registerTopBar()
  }, [isAvailable, registerTopBar])

  if (!assistant?.isAvailable) return null
  const { nudge } = assistant

  return (
    <AssistantAskBar
      compact={compact}
      isPanelOpen={assistant.isPanelOpen}
      hasConversation={assistant.hasConversation}
      nudge={nudge}
      suggestions={assistant.suggestions}
      buttonRef={assistant.launcherRef}
      page={pathname}
      onAsk={(text, source, caseId) =>
        assistant.askQuestion(
          { text, source, caseId },
          source === 'typed' ? 'ask_input' : 'suggestion'
        )
      }
      onOpenPanel={() => assistant.openPanel('icon')}
      onResume={() => assistant.openPanel('resume')}
      onClosePanel={assistant.closePanel}
      onReview={() => {
        if (nudge) assistant.reviewNudge(nudge)
      }}
      onDismissNudge={() => {
        if (nudge) assistant.dismissNudge(nudge)
      }}
    />
  )
}

export default AssistantTopBar
